document.addEventListener('DOMContentLoaded', function() {
    // Function to set all .step-by-step__step-content elements to the same height
    function setEqualHeight() {
        const stepContents = document.querySelectorAll('.step-by-step__step-content');
        
        if (!stepContents.length) return;
        
        // Reset heights to auto to get natural height
        stepContents.forEach(content => content.style.height = 'auto');
        
        // Calculate the max height among all .step-by-step__step-content elements
        let maxHeight = 0;
        stepContents.forEach(content => {
            const contentHeight = content.offsetHeight;
            if (contentHeight > maxHeight) {
                maxHeight = contentHeight;
            }
        });
        
        // Apply the max height to all .step-by-step__step-content elements
        stepContents.forEach(content => content.style.height = `${maxHeight}px`);
    }
    
    // Run the function initially
    setEqualHeight();
    
    // Recalculate heights on window resize
    window.addEventListener('resize', setEqualHeight);
});